var map = {
	"./about.svg": "134d",
	"./compare.svg": "8b50",
	"./content-management.svg": "79f1",
	"./dashboard.svg": "312f",
	"./lists.svg": "4d4b",
	"./monitor.svg": "11dc",
	"./monitoring.svg": "518b",
	"./ozon.svg": "a246",
	"./review-management.svg": "71c8",
	"./seo.svg": "eaf1",
	"./sf-consulting.svg": "59d9",
	"./shops.svg": "74e7",
	"./socials/TG.svg": "5edb",
	"./socials/VK.svg": "a40f",
	"./socials/YT.svg": "17b3",
	"./socials/wechat_qr.jpg": "7253",
	"./wb.svg": "9002"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "3063";